export interface WidgetInterface {
  hasProjects: boolean;
  reposFilter: string[];
}

export interface DeploymentSummaryStats {
  open_issues_count: number;
  severity_high_count: number;
  pr_fix_rate: number;
  open_issues_delta: number;
  severity_high_delta: number;
  pr_fix_rate_delta: number;
}

export interface CategorySummary {
  category: string;
  open_findings_count: number;
}

export interface CategorySummaryResponse {
  categories: CategorySummary[];
}

export interface ProjectAnalyticsItem {
  project_name: string;
  open_findings_count: number;
  severity_high_count: number;
  fixed_findings_rate: number;
}

export interface ProjectAnalyticsResponse {
  project_analytics_items: ProjectAnalyticsItem[];
}

export interface RuleAnalyticsItem {
  rule_name: string;
  dislike_count: number;
  ignore_rate: number;
  fix_rate: number;
  count: number;
}

export type RulesEventType = "fired" | "disliked" | "ignored" | "fixed";

export const DEFAULT_RULES_EVENT = "fired";

export interface RuleAnalyticsResponse {
  rules: RuleAnalyticsItem[];
  event_type: RulesEventType;
  total_results_count: number;
}
